import { Controller } from "@hotwired/stimulus"

// Wires the "Saved addresses" picker on the checkout delivery form.
// Selecting a saved-address radio populates the hidden delivery_address
// field (and the delivery-instructions textarea) from the radio's data
// attributes; selecting "Use a new address" reveals the free-form
// delivery_address textarea so the customer can type one.
export default class extends Controller {
  static targets = ["radio", "customField", "addressInput", "notesInput"]

  connect() {
    // Apply whatever is initially checked (default address).
    const checked = this.radioTargets.find((r) => r.checked)
    if (checked) this.#apply(checked)
  }

  select(event) {
    this.#apply(event.currentTarget)
  }

  #apply(radio) {
    const useNew = radio.value === "new"

    if (this.hasCustomFieldTarget) {
      this.customFieldTarget.classList.toggle("hidden", !useNew)
    }

    if (this.hasAddressInputTarget) {
      if (useNew) {
        // Editable: clear the value so the user types their own address.
        this.addressInputTarget.value = ""
        this.addressInputTarget.focus()
      } else {
        this.addressInputTarget.value = radio.dataset.address || ""
      }
    }

    if (this.hasNotesInputTarget) {
      this.notesInputTarget.value = (!useNew && radio.dataset.instructions) ? radio.dataset.instructions : ""
    }
  }
}
